import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ToastConfig = () => (
  <ToastContainer
    position="top-right"
    autoClose={3000}
    hideProgressBar={false}
    newestOnTop={false}
    closeOnClick
    rtl={false}
    pauseOnFocusLoss
    draggable
    theme="colored"
    style={{
      zIndex: 9999,
      width: "350px",
      height: "80px",
      padding: "10px",
      borderRadius: "10px",
      fontSize: "16px",
      fontWeight: "bold",
      color: "#fff",
      fontFamily: "Arial, sans-serif",
    }}
  />
);

export default ToastConfig;
